// router.push(url, as, { shallow: true }) isn't good enough in some cases.
// It causes a rerender which disturbs the state of the component and
// makes scrolling jumpy. Instead, we can use this function which doesn't
// affect the state of the component.

export const shallowNavigate = (path: string) => {
  window.history.replaceState(
    { ...window.history.state, as: path, url: path },
    "",
    path
  );
};
